import About from '../../components/About/About'

export default function AboutMe(){
    return(
        <>
            <About url="about" />
        </>
    )
}